export const contactConflictTypes = {
    duplicateEmail: 1,
    duplicateName: 2
};
